import { Request } from './Request';

export class FilterSort {
    constructor(filterSort, blockSelector = 'filter-sort') {
        this.filterSort = filterSort;

        this.ADAPTIVE_RESULT_SELECTOR = `${blockSelector}__adaptive-result`;
        this.ADAPTIVE_RESULT_SELECTOR_OPEN = `${blockSelector}__adaptive-result--open`;
        this.LINK_SELECTOR = `${blockSelector}__link`;
        this.LINK_SELECTOR_ACTIVE = `${this.LINK_SELECTOR}--active`;

        // селекторы для адаптива
        this.LIST_SELECTOR = `${blockSelector}__list`;
        this.LIST_SELECTOR_OPEN = `${blockSelector}__list--open`;

        // запросы в ссылках
        this.AJAX = new Request();
        this.queries = [];

        this.init();
    }

    init() {
        if (!this.filterSort) return;

        this.adaptiveResult = this.filterSort.querySelector(`.${this.ADAPTIVE_RESULT_SELECTOR}`);
        this.list = this.filterSort.querySelector(`.${this.LIST_SELECTOR}`);
        this.links = Array.from(this.filterSort.querySelectorAll(`.${this.LINK_SELECTOR}`));

        const defaultActive = this.filterSort.querySelector(`.${this.LINK_SELECTOR_ACTIVE}`);

        if (!defaultActive) {
            return;
            // this.links[0].classList.add(this.LINK_SELECTOR_ACTIVE);
        }

        this.checkSearchParams();
        this.setActive(defaultActive || this.links[0]);
        this.toggleAdaptiveSelector();
        this.sortButtonsHandlers();
    }

    getLinks() {
        return this.links;
    }

    toggleAdaptiveSelector() {
        if (!this.adaptiveResult) return;

        this.adaptiveResult.addEventListener('click', (evt) => {
            evt.preventDefault();
            console.log('toggleAdaptiveSelector click');

            this.list.classList.toggle(this.LIST_SELECTOR_OPEN);
            this.adaptiveResult.classList.toggle(this.ADAPTIVE_RESULT_SELECTOR_OPEN);
        });
    }

    removeActiveClass() {
        this.links.forEach((link) => {
            link.classList.remove(this.LINK_SELECTOR_ACTIVE);
        });
    }

    setActive(link) {
        this.removeActiveClass();
        link.classList.add(this.LINK_SELECTOR_ACTIVE);

        this.list.classList.remove(this.LIST_SELECTOR_OPEN);
        this.adaptiveResult.classList.remove(this.ADAPTIVE_RESULT_SELECTOR_OPEN);
        this.adaptiveResult.children[0].innerHTML = link.innerHTML;
    }

    resetActive() {
        this.removeActiveClass();
        this.links[0].classList.add(this.LINK_SELECTOR_ACTIVE);
    }

    prepareQueryData() {
        const data = [];
        if (this.filterSort) {
            const activeLink = this.filterSort.querySelector(`.${this.LINK_SELECTOR_ACTIVE}`);
            if (activeLink) {
                const { href } = activeLink;
                const { searchParams } = new URL(href);

                Array.from(searchParams.keys()).forEach((item) => {
                    data.push({ key: item, value: searchParams.get(item) });
                });
            }
        }

        const formData = new FormData();
        data.forEach((item) => {
            formData.append(item.key, item.value);
        });

        return formData;
    }

    sortButtonsHandlers() {
        this.links.forEach((button) => {
            button.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.setActive(button);

                const formData = this.prepareQueryData();
                this.AJAX.request(formData);
            });
        });
    }

    checkSearchParams() {
        const { searchParams } = new URL(window.location);
        const formData = new FormData();
        formData.append('sort-order', searchParams.get('sort-order'));
        formData.append('sort-by', searchParams.get('sort-by'));
        this.AJAX.setInitPreviousFormData(formData);
    }
}
